import React, { useEffect, useState } from 'react';
import nodeLogos from 'src/utils/nodeLogos';
import { LinkControlPanelInputForm } from './link-input-form';

import { LinkDisplayOption, LinkResponse } from './types';

type Props = {
  onNewUrl: (url: string) => void;
};

type ESIGNATURE_LOGO = 'pandadoc' | 'docusign';

const LOGOS: ESIGNATURE_LOGO[] = ['pandadoc', 'docusign'];

export const AddEsignatureLinkControlPanel = ({ onNewUrl }: Props) => {

  return (
    <div className='flex flex-col space-y-4'>
      <LinkControlPanelInputForm url={''} onNewUrl={onNewUrl} autoFocus={true} placeholder='Paste document URL' />
      <div className='flex items-center space-x-4'>
        <div className='text-neue-journey-small text-neue-journey-fg'>Recommended</div>
        {LOGOS.map((host: ESIGNATURE_LOGO) => {
          const HostLogo = nodeLogos[host];
          if (!HostLogo) return null;

          return <HostLogo className='h-4 w-auto' />;
        })}
      </div>
    </div>
  );
};
